<template>
    <div class="list-item">
        <div class="rank"><slot name="rank"></slot></div>
        <div class="stock">
            <div class="name"><slot name="name"></slot></div>
            <div class="code"><slot name="code"></slot></div>
        </div>
        <div class="value"><slot name="value"></slot></div>
    </div>
</template>

<script>
export default {
    name: 'listItem',
    props: {
        rank: Number,
    },
    mounted(){
        if(this.rank < 4){
            let rank = this.$el.childNodes[0];
            let imgSrc = "background-image:url('./images/top/" + this.rank + ".png')";
            rank.setAttribute('style', imgSrc)
            rank.innerHTML = '';
        }
    }
}
</script>

<style lang="scss" scoped>

.list-item {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    border-bottom: solid .01rem #DCDCDC;
}

.rank {
    width: .52rem;
    padding: .30rem;
    font-size: .3rem;
    color: #999999;
    text-align: center;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center center;
}

.stock {
    width: 3rem;
    padding: .30rem;
    text-align: left;
}

.name {
    font-family: 'Noto Sans SC', sans-serif;
    font-size: .3rem;
    font-weight: 500;
    color: #333333;
}

.code {
    font-family: 'Noto Sans SC', sans-serif;
    font-size: .24rem;
    font-weight: 400;
    color: #999999;
}

.value {
    width: 1.58rem;
    padding: .30rem;
    font-family: DINAlternate, 'Noto Sans SC', sans-serif;
    font-size: .32rem;
    font-weight: 500;
    color: #FF7A24;
    text-align: right;
}

</style>